<template>
  <!-- 综合管理-圈子评论管理 -->
  <basic-container>
    <avue-crud
      ref="crud"
      :option="tableOption"
      :table-loading="loading"
      :data="tableData"
      :page.sync="tablePage"
      :search.sync="searchForm"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="loadData"
      @on-load="loadData"
      @row-click="rowClick"
    >
      <template slot-scope="{ row }" slot="menu">
        <el-button
          v-if="permissionList.visibleBtn && row.showFlag == 0"
          size="small"
          type="text"
          @click.stop="showConfirm('visible', row)"
        >
          显示
        </el-button>
        <el-button
          v-if="permissionList.hiddenBtn && row.showFlag == 1"
          size="small"
          type="text"
          @click.stop="showConfirm('hidden', row)"
        >
          不显示
        </el-button>
      </template>
      <template slot="showFlag" scope="{ row }">
        <span>{{ row.showFlag == 1 ? '√' : '' }}</span>
      </template>
    </avue-crud>
    <!-- 弹框 -->
    <el-dialog
      :title="dialogTitle"
      width="80%"
      :visible.sync="isDialogShow"
      :before-close="beforeCloseDialog"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      :destroy-on-close="true"
    >
      <Form
        v-if="isDialogShow"
        :dialogType="dialogType"
        :circleId="rowData.circleId"
        :projectId="searchForm.projectId"
        @close="closeDialog"
      ></Form>
    </el-dialog>
  </basic-container>
</template>

<script>
import Form from './circle-form';
import { mapGetters } from 'vuex';
import { getProjectListApi } from '@/api/call-system/index';
import { getPageListApi, visibleApi } from '@/api/general-manage/social-circle/comment';

export default {
  components: {
    Form,
  },
  data() {
    return {
      isPageCache: false, // 当前页面是否从后台直接显示的 true-从后台直接显示的，也就是页面是缓存状态 false-重新加载的
      oldProjectId: '', // 旧项目id，重置搜索条件和新增时需要使用
      projectList: [], // 项目列表
      searchForm: {}, // 搜索条件
      dialogType: '', // 弹框的类型
      dialogTitle: '', // 弹框显示的标题
      isDialogShow: false, // 弹框是否显示着
      needCloseConfirm: false, // 关闭弹框时是否需要确认弹框，该值是根据场景动态调整的
      loading: false, // 是否正在加载表格数据
      tableData: [], // 表格数据
      // 数据的分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格显示的配置项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        searchMenuSpan: 18,
        searchLabelWidth: 100,
        labelWidth: 100,
        column: [
          {
            label: '项目名称',
            prop: 'projectId',
            dicData: [],
            props: {
              label: 'name',
              value: 'id',
            },
            type: 'select',
            hide: true,
            showColumn: false,
            display: false,
            // search: true,
            // searchClearable: false,
          },
          {
            label: '圈子内容',
            prop: 'circleContent',
            overHidden: true,
          },
          {
            label: '评论用户',
            prop: 'replyerName',
          },
          {
            label: '评论内容',
            prop: 'content',
            overHidden: true,
            search: true,
            maxlength: 50,
            showWordLimit: true,
          },
          {
            label: '创建日期',
            prop: 'createTime',
          },
          {
            label: '显示',
            prop: 'showFlag',
            slot: true,
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        visibleBtn: this.vaildData(this.permission.socialCircle_commentManage_visible, false),
        hiddenBtn: this.vaildData(this.permission.socialCircle_commentManage_hidden, false),
      };
    },
  },
  created() {
    getProjectListApi().then(({ data }) => {
      this.projectList = data || [];
      if (this.projectList.length > 0) {
        this.findObject(this.tableOption.column, 'projectId').dicData = this.projectList;
        this.searchForm.projectId = this.projectList[0].id;
        this.loadData();
      }
    });
  },
  mounted() {
    this.ajustView();
  },
  activated() {
    // 从缓存状态恢复窗口显示时重新请求下数据
    if (this.isPageCache) {
      this.loadData();
    }
    this.isPageCache = true;
    // 当从其它窗口切换回当前页面时，表格线会错乱，加上如下处理可解决此问题
    this.$nextTick(() => {
      this.$refs.crud.refreshTable();
    });
  },
  methods: {
    /* 调整视图区域 */
    ajustView() {
      const tableInitH = this.bodyHeight - 335; // 表格区域初始化高度
      const searchH = 56; // 搜索区域占的高度
      this.tableOption.height = tableInitH;

      this.$nextTick(() => {
        setTimeout(() => {
          let children = this.$refs.crud.$children[1].$children;
          children[children.length - 2].$el.addEventListener('click', () => {
            if (this.tableOption.height == tableInitH) {
              this.tableOption.height = tableInitH + searchH;
            } else {
              this.tableOption.height = tableInitH;
            }
            this.$refs.crud.getTableHeight();
          });
        });
      });

      // 当窗口尺寸发生变化时，表格线会错乱，加上如下处理可解决此问题
      setTimeout(() => {
        window.onresize = () => {
          this.$nextTick(() => {
            this.$refs.crud.refreshTable();
          });
        };
      });
    },
    /* 加载表格数据 */
    loadData(page) {
      if (!this.searchForm.projectId) return;
      this.oldProjectId = this.searchForm.projectId;
      page = page || this.tablePage;
      this.loading = true;
      getPageListApi(
        Object.assign(
          {
            projectId: this.projectId,
            current: page.currentPage,
            size: page.pageSize,
          },
          this.searchForm
        )
      ).then(({ data }) => {
        this.tablePage.total = data.total;
        this.tableData = data.records;
        this.loading = false;
      });
    },
    /* 重置搜索 */
    searchReset() {
      this.searchForm = {
        projectId: this.oldProjectId,
      };
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange(params, done) {
      this.searchForm = params;
      this.tablePage.currentPage = 1;
      this.loadData();
      done();
    },
    /* 操作确认弹框 */
    showConfirm(type, row) {
      this.$confirm('确认' + (type == 'visible' ? '显示？' : '不显示？'), {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return visibleApi({
            id: row.id,
            showFlag: type == 'visible' ? 1 : 0,
          });
        })
        .then(() => {
          this.loadData();
          this.$message.success('操作成功!');
        });
    },
    /* 行点击 */
    rowClick(row) {
      this.openDialog('view', this.tableData[row.$index]);
    },
    /* 打开弹框 */
    openDialog(type, rowData = {}) {
      let titles = {
        view: '查看',
      };
      this.dialogTitle = titles[type];
      this.dialogType = type;
      this.rowData = rowData;
      if (type == 'view') {
        this.needCloseConfirm = false;
      } else {
        this.needCloseConfirm = true;
      }
      this.isDialogShow = true;
    },
    /* 关闭表单弹框的确认框 */
    beforeCloseDialog(done) {
      if (!this.needCloseConfirm) {
        if (typeof done == 'function') {
          done();
        } else {
          this.dialogType = '';
          this.isDialogShow = false;
        }
      } else {
        this.$confirm(' 是否关闭继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            if (typeof done == 'function') {
              done();
            } else {
              this.dialogType = '';
              this.isDialogShow = false;
            }
          })
          .catch(() => {});
      }
    },
    /* 关闭表单弹框 */
    closeDialog() {
      this.dialogType = '';
      this.isDialogShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
/* 搜索按钮靠右对齐 */
::v-deep .avue-form__menu--center {
  text-align: right !important;
}

/* 表单的每一项宽度最大化 */
::v-deep .el-form-item {
  width: 100%;
}
</style>
